/* eslint-disable import/no-anonymous-default-export */

import LenderActionTypes from "./lender.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addLenderDetailsResponse: null,
  updateLenderDetailsResponse: null,
  getLenderListResponse: null,
  getLenderListArr: [],
  fetchLenderDetailsResponse: null,
  fetchLenderDetailsArr: [],
  deleteLenderDetailsResponse: null,
  lenderListResponseArr: [],
  lenderListFetchResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD LENDER DETAILS START *********************** */
    case LenderActionTypes.ADD_LENDER_DETAILS_SUCCESS:
      return { ...state, addLenderDetailsResponse: action.payload };

    case LenderActionTypes.ADD_LENDER_DETAILS_FAILURE:
      return { ...state, addLenderDetailsResponse: action.payload };

    case LenderActionTypes.ADD_LENDER_DETAILS_RESPONSE_CHANGED:
      return { ...state, addLenderDetailsResponse: null };
    /** ***************** ADD LENDER DETAILS END *********************** */

    /** ***************** UPDATE LENDER DETAILS START *********************** */
    case LenderActionTypes.UPDATE_LENDER_DETAILS_SUCCESS:
      return { ...state, updateLenderDetailsResponse: action.payload };

    case LenderActionTypes.UPDATE_LENDER_DETAILS_FAILURE:
      return { ...state, updateLenderDetailsResponse: action.payload };

    case LenderActionTypes.UPDATE_LENDER_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateLenderDetailsResponse: null };
    /** ***************** UPDATE LENDER DETAILS END *********************** */

    /** ***************** GET LENDER DETAILS START *********************** */
    case LenderActionTypes.GET_LENDER_LIST_SUCCESS:
      return {
        ...state,
        getLenderListResponse: action.payload,
        getLenderListArr: docodeHexResponse(
          action.payload,
          "GetAllLenderPaginationKey",
        ),
      };

    case LenderActionTypes.GET_LENDER_LIST_FAILURE:
      return {
        ...state,
        getLenderListResponse: action.payload,
        getLenderListArr: [],
      };

    case LenderActionTypes.GET_LENDER_LIST_RESPONSE_CHANGED:
      return { ...state, getLenderListResponse: null };
    /** ***************** GET LENDER DETAILS END *********************** */

    /** ***************** FETCH LENDER DETAILS START *********************** */
    case LenderActionTypes.FETCH_LENDER_DETAILS_SUCCESS:
      return {
        ...state,
        fetchLenderDetailsResponse: action.payload,
        fetchLenderDetailsArr: docodeHexResponse(
          action.payload,
          "FetchLenderKey",
        ),
      };

    case LenderActionTypes.FETCH_LENDER_DETAILS_FAILURE:
      return { ...state, fetchLenderDetailsResponse: action.payload };

    case LenderActionTypes.FETCH_LENDER_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchLenderDetailsResponse: null,
        fetchLenderDetailsArr: [],
      };
    /** ***************** FETCH LENDER DETAILS END *********************** */

    /** ***************** DELETE LENDER DETAILS START *********************** */
    case LenderActionTypes.DELETE_LENDER_DETAILS_SUCCESS:
      return { ...state, deleteLenderDetailsResponse: action.payload };

    case LenderActionTypes.DELETE_LENDER_DETAILS_FAILURE:
      return { ...state, deleteLenderDetailsResponse: action.payload };

    case LenderActionTypes.DELETE_LENDER_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteLenderDetailsResponse: null };
    /** ***************** DELETE LENDER DETAILS END *********************** */

    /** ***************** START FETCH LENDER LIST DETAILS ******************************* */
    case LenderActionTypes.LENDER_LIST_FETCH_SUCCESS:
      return {
        ...state,
        lenderListFetchResponse: action.payload,
        lenderListResponseArr: docodeHexResponse(
          action.payload,
          "AllLenderMasterKey",
        ),
      };

    case LenderActionTypes.LENDER_LIST_FETCH_FAILURE:
      return {
        ...state,
        lenderListFetchResponse: action.payload,
        lenderListResponseArr: [],
      };

    case LenderActionTypes.LENDER_LIST_FETCH_RESPONSE_CHANGED:
      return { ...state, lenderListFetchResponse: null };

    /** ***************** END FETCH LENDER LIST DETAILS ******************************* */

    default:
      return state;
  }
};
